// extracted by mini-css-extract-plugin
export var markdown = "_se-0";
export var tableWrapper = "_se-1";